import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
var _createContextStore = createContextStore({
    widgetID: undefined,
    initializationError: undefined,
    isHCaptchaEnabled: false,
    submittedTokens: []
}, {
    name: "HCaptchaStore"
}), useHCaptchaStore = _createContextStore.useStore, HCaptchaStoreProvider = _createContextStore.Provider;
export { useHCaptchaStore, HCaptchaStoreProvider };
